export const siteSettings = {
  name: "Cloud Vault Markets",
  link: "https://cloudvaultmarkets.net",
  email: "support@cloudvaultmarkets.net",
  appLink: "https://app.cloudvaultmarkets.net",
};
